import React from "react";
import styles from "./PlaydateInviteBaseUnit.module.css";
import letterhead from "../../assets/letterhead.svg";
import purpleLogo from "../../assets/icons/purple-logo.svg";

interface PlaydateInviteLetterheadProps {
    logo?: React.ReactNode; // optional custom logo node (e.g., <img />, <svg />, etc.)
}

const PlaydateInviteLetterhead: React.FC<PlaydateInviteLetterheadProps> = ({ logo }) => {
    return (
        <div className={styles.envelope}>
            <img src={letterhead} className={styles.flap}></img>
            <div className={styles.logo}>
                {logo ?? <img src={purpleLogo} className={styles.defaultLogo} />}
            </div>
        </div>
    );
};

export default PlaydateInviteLetterhead;
